import { render, staticRenderFns } from "./VProjectList.vue?vue&type=template&id=5d666c16&scoped=true&"
import script from "./VProjectList.vue?vue&type=script&lang=ts&"
export * from "./VProjectList.vue?vue&type=script&lang=ts&"
import style0 from "./VProjectList.vue?vue&type=style&index=0&id=5d666c16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d666c16",
  null
  
)

export default component.exports